export const HOW_TO_HOST_LINK = 'https://www.equitabledinners.com/how-to-host'
